import { render, staticRenderFns } from "./ErgoDesignModule.vue?vue&type=template&id=4b9f7b79&"
import script from "./ErgoDesignModule.vue?vue&type=script&lang=ts&"
export * from "./ErgoDesignModule.vue?vue&type=script&lang=ts&"
import style0 from "./ErgoDesignModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports